import request from '@/utils/request'
//查询自定义表单
export function queryFrom(query) {
  return request({
    url: 'sip/call-form',
    method: 'get',
    params: query
  })
}
//新增自定义表单
export function addForm(data) {
  return request({
    url: 'sip/call-form',
    method: 'post',
    data: data
  })
}

//查询外呼结果
export function callResult(query) {
  return request({
    url: 'sip/call-result/list',
    method: 'get',
    params: query
  })
}

//清空
export function delCallform() {
  return request({
    url: 'sip/call-form',
    method: 'delete'
  })
}

//模板根据类型查询模板列表
export function callForm(formType) {
  return request({
    url: 'sip/call-form/list/'+formType,
    method: 'get',
  })
}

//模板新增&修改
export function addCallForm(data) {
  return request({
    url: 'sip/call-form',
    method: 'post',
    data: data
  })
}
//模板删除
export function delCallForm(fromId) {
  return request({
    url: 'sip/call-form/' + fromId,
    method: 'delete'
  })
}
//模板状态修改
export function updateStatus(formId) {
  return request({
    url: 'sip/call-form/update-status/'+formId,
    method: 'put',
  })
}
//设置/取消默认模板
export function upDataDefault(data) {
  return request({
    url: 'sip/call-form/update-default',
    method: 'put',
    data: data
  })
}

//根据模板查留资记录
export function callResultList(formId,query) {
  return request({
    url: 'sip/call-record/list/'+formId,
    method: 'get',
    params: query
  })
}